import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentTask } from '../../../../../selectors/admin/work-orders/details/details';
import './QuotesRequestModal.css';
import addPng from '../../../../../images/add.png';
import removePng from '../../../../../images/remove.png';
import leftArrowPng from '../../../../../images/left-arrow.png';
import checkCirclePng from '../../../../../images/check-circle.png';
import Date from '../../../../shared/text/Date';
import DatetimePicker from '../../../../shared/datetime-picker/DatetimePicker';
import {
  getBidDueDate,
  getCurrentView,
  getSelectedContractor,
  getSelectedContractors,
  getShowQuotesRequestModal,
} from '../../../../../selectors/admin/work-orders/details/quotes-request';
import {
  addContractor,
  closeQuotesRequestModal,
  goBack,
  removeContractor,
  selectContractor,
  setBidDueDate,
  showPreview,
  submitQuotesRequestStart,
  submitMultipleQuotesRequestStart,
} from '../../../../../actions/admin/work-orders/details/quotes-request';
import { getSelectedTasks } from 'selectors/admin/work-orders/details/details';
import SearchableDropDown from '../../../../shared/dropdown/SearchableDropDown';
import ContractorsApi from '../../../../../services/api/contractors-api';
import DetailsInfoItem from '../../../../shared/details/DetailsInfoItem';
import ImageUpload from '../../../../shared/image-upload/ImageUpload';
import ConfirmationPanel from '../../../../shared/confirmation/ConfirmationPanel';
import FormModal from '../../../../shared/modal/FormModal';
import numeral from 'numeral';
import {
  getCurrentWorkOrder,
  getTasks,
} from '../../../../../selectors/admin/work-orders/work-orders';
import { Alert } from 'react-bootstrap';
import {
  getRange,
  todayValidation,
} from '../../../../../services/utils/date-util';
import moment from 'moment';
import { goToWorkOrder } from '../../../../../actions/admin/work-orders/work-orders';

/**
 * Modal for requesting bids from a task (by the admin)
 */
class QuotesRequestModal extends Component {
  handleClose = (event) => {
    event.preventDefault();
    this.props.dispatch(closeQuotesRequestModal());
  };

  handleBidDueDateChange = (value) => {
    this.props.dispatch(setBidDueDate(value));
  };

  handleContractorSelect = (option) => {
    this.props.dispatch(selectContractor(option));
  };

  handleAddClick = (event) => {
    event.preventDefault();
    if (this.props.selectedContractor !== null && this.canSelectContractor()) {
      this.props.dispatch(addContractor(this.props.selectedContractor));
    }
  };

  handleRemoveClick = (event, index) => {
    event.preventDefault();
    this.props.dispatch(removeContractor(index));
  };

  handleNext = (event) => {
    event.preventDefault();
    this.props.dispatch(showPreview());
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.props.currentTask) {
      this.props.dispatch(
        submitQuotesRequestStart(
          this.props.currentTask.id,
          this.props.selectedContractors,
          this.props.bidDueDate
        )
      );
    } else {
      this.props.dispatch(
        submitMultipleQuotesRequestStart(
          this.props.currentWorkOrder.id,
          Object.keys(this.props.selectedTasks),
          this.props.selectedContractors[0].value,
          this.props.bidDueDate
        )
      );
    }
  };

  handleBackArrow = (event) => {
    event.preventDefault();
    this.props.dispatch(goBack());
  };

  handleContinueClick = (event) => {
    event.preventDefault();
    this.props.dispatch(closeQuotesRequestModal());
    this.props.dispatch(goToWorkOrder(this.props.currentWorkOrder.id));
  };

  completionDate = (currentTask) => {
    if (currentTask) {
      return currentTask.completion_date;
    } else if (
      this.props.tasks.length > 0 &&
      Object.keys(this.props.selectedTasks).length > 0
    ) {
      const selectedTasks = this.props.selectedTasks;
      return this.props.tasks.reduce(function (previousTask, task) {
        if (selectedTasks[task.id] !== undefined) {
          return moment(previousTask.completion_date) <
            moment(task.completion_date)
            ? previousTask
            : task;
        } else {
          return previousTask;
        }
      }).completion_date;
    }

    return null;
  };

  trades = (currentTask) => {
    if (currentTask) {
      return [currentTask.trade.id];
    } else if (
      this.props.tasks.length > 0 &&
      Object.keys(this.props.selectedTasks).length > 0
    ) {
      const selectedTasks = this.props.selectedTasks;
      return this.props.tasks
        .map((task) =>
          selectedTasks[task.id] !== undefined ? task.trade.id : null
        )
        .filter((obj) => obj);
    }

    return [];
  };

  canSelectContractor = () => {
    return (
      this.props.currentTask || this.props.selectedContractors.length === 0
    );
  };

  static loadContractors(tradeIds, input) {
    return ContractorsApi.searchContractors(input, tradeIds).then(
      (response) => {
        if (response.ok) {
          return {
            ok: true,
            options: response.contractors.map((element) => {
              return {
                value: element.id,
                label: element.name,
              };
            }),
          };
        } else {
          return {
            ok: false,
            errors: response.errors,
          };
        }
      }
    );
  }

  render() {
    // Find current task entity (this.props.currentTask is actually the form values)
    const currentTaskId =
      this.props.currentTask !== null ? this.props.currentTask.id : 0;
    const currentTask = this.props.tasks.find(
      (element) => element.id === currentTaskId
    );
    const selectedTasks = this.props.selectedTasks;
    const completionDate = this.completionDate(currentTask);
    const trades = this.trades(currentTask);

    let showHeader = false;
    let title;
    if (this.props.currentView !== 'message') {
      if (currentTask) {
        title =
          'Task #' +
          numeral(currentTask.number).format('00') +
          ': ' +
          currentTask.trade.label;
      } else {
        title = (
          <ul className="selected-tasks-list">
            {this.props.tasks.map(function (task) {
              return (
                selectedTasks[task.id] !== undefined && (
                  <li key={task.id}>
                    Task #{numeral(task.number).format('00')}:{' '}
                    {task.trade.label}
                  </li>
                )
              );
            })}
          </ul>
        );
      }

      showHeader = true;
    }

    return this.props.show ? (
      <FormModal
        className="quotes-request-modal"
        show={this.props.show}
        showHeader={showHeader}
        title={title}
        onClose={this.handleClose}
      >
        {this.props.currentView === 'form' &&
          this.getFormPage(completionDate, trades)}

        {this.props.currentView === 'preview' &&
          this.getPreviewPage(completionDate)}

        {this.props.currentView === 'message' && (
          <ConfirmationPanel
            image={checkCirclePng}
            firstLine="Thank you!"
            lines={['Your request for bid has been sent.']}
            buttons={[
              <input
                type="button"
                className="btn button button-orange"
                value="Continue"
                onClick={this.handleContinueClick}
              />,
            ]}
          />
        )}
      </FormModal>
    ) : null;
  }

  getPreviewPage(completionDate) {
    return (
      <div className="preview-page">
        <div>
          <img
            src={leftArrowPng}
            alt={'left-arrow'}
            onClick={this.handleBackArrow}
          />
        </div>

        <div className="h2">Request Quotes</div>

        <div className="task-details-container">
          <div>
            <div>
              <DetailsInfoItem
                lines={[
                  this.props.currentWorkOrder.building.location
                    .street_address_1,
                  this.props.currentWorkOrder.building.location.city +
                    ', ' +
                    this.props.currentWorkOrder.building.location.state +
                    ' ' +
                    this.props.currentWorkOrder.building.location.zip,
                  this.props.currentWorkOrder.building.name !== '' &&
                  this.props.currentWorkOrder.building.name !== null
                    ? this.props.currentWorkOrder.building.name
                    : '',
                ]}
                title="BUILDING"
              />
            </div>
            <div>
              <DetailsInfoItem
                lines={this.props.currentWorkOrder.working_hours}
                title="AVAILABLE WORKING HOURS"
              />
            </div>
          </div>
          {this.props.currentTask && (
            <div>
              <DetailsInfoItem
                lines={[this.props.currentTask.description]}
                title="DESCRIPTION"
              />
            </div>
          )}
        </div>

        {this.props.currentTask && (
          <div className="images-container">
            <ImageUpload
              images={this.props.currentTask.images}
              readOnly={true}
            />
          </div>
        )}

        <div className="contractors-clients-container">
          <ul>
            {this.props.selectedContractors.map((element, index) => {
              return (
                <li key={element.value}>
                  <span>{element.label}</span>
                </li>
              );
            })}
          </ul>

          <div className="completion-date-container">
            <span className="body-bold">Target Completion Date</span>
            <span className="body-bold">
              <Date format="LL" value={completionDate} />
            </span>
          </div>

          <div className="bid-due-date-container">
            <span className="body-regular">Bid due Date</span>
            <span>
              <Date value={this.props.bidDueDate} />
            </span>
          </div>
        </div>

        {this.showDatesWarning(completionDate) && (
          <Alert bsStyle="warning">
            Bid due date is 5 days or less from Task completion date. Please
            confirm.
          </Alert>
        )}

        <div className="button-container">
          <input
            className="btn button button-orange"
            type="button"
            value="Submit"
            onClick={this.handleSubmit}
          />
        </div>
      </div>
    );
  }

  getFormPage(completionDate, trades) {
    this.completionDateMoment = moment(completionDate);

    return (
      <div className="form-page">
        <div className="h2">Request Bids</div>

        <div className="contractors-clients-container">
          <ul>
            {this.props.selectedContractors.map((element, index) => {
              return (
                <li key={element.value}>
                  <span>{element.label}</span>
                  <img
                    src={removePng}
                    alt="remove"
                    onClick={(event) => this.handleRemoveClick(event, index)}
                  />
                </li>
              );
            })}
          </ul>
        </div>

        <div>
          <div className="drop-down-container">
            <SearchableDropDown
              autoload={false}
              loadOptions={QuotesRequestModal.loadContractors.bind(
                this,
                trades
              )}
              placeholder="Sub-Contractor Name"
              value={
                this.props.selectedContractor !== null
                  ? this.props.selectedContractor.value
                  : null
              }
              onChange={this.handleContractorSelect}
            />
          </div>
          <span>
            <img
              className={
                this.props.selectedContractor === null ||
                !this.canSelectContractor()
                  ? 'disabled'
                  : ''
              }
              src={addPng}
              alt="add"
              onClick={this.handleAddClick}
            />
          </span>
        </div>

        <div className="completion-date-container">
          <span className="body-bold">Target Completion Date</span>
          <span className="body-bold">
            <Date format="LL" value={completionDate} />
          </span>
        </div>

        <div className="bid-due-date-container">
          <span className="body-regular">Bid due Date</span>
          <span>
            <DatetimePicker
              isValidDate={this.validateBidDueDate.bind(this)}
              placeholder=""
              value={this.props.bidDueDate}
              onChange={this.handleBidDueDateChange}
            />
          </span>
        </div>

        {this.showDatesWarning(completionDate) && (
          <Alert bsStyle="warning">
            Bid due date is 5 days or less from Task completion date. Please
            confirm.
          </Alert>
        )}

        <div className="button-container">
          <input
            className="btn button button-orange"
            disabled={
              this.props.selectedContractors.length === 0 ||
              this.props.bidDueDate === null
            }
            type="button"
            value="Next"
            onClick={this.handleNext}
          />
        </div>
      </div>
    );
  }

  validateBidDueDate(date) {
    return (
      todayValidation(date) && date.isSameOrBefore(this.completionDateMoment)
    );
  }

  showDatesWarning(targetCompletionDate) {
    let result = false;
    if (targetCompletionDate !== null && this.props.bidDueDate !== null) {
      const range = getRange(this.props.bidDueDate, targetCompletionDate);
      result = range.years === 0 && range.months === 0 && range.days <= 5;
    }
    return result;
  }
}

export default connect((state) => {
  return {
    bidDueDate: getBidDueDate(state),
    currentTask: getCurrentTask(state),
    currentView: getCurrentView(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    selectedContractor: getSelectedContractor(state),
    selectedContractors: getSelectedContractors(state),
    show: getShowQuotesRequestModal(state),
    tasks: getTasks(state),
    selectedTasks: getSelectedTasks(state),
  };
})(QuotesRequestModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/quotes/QuotesRequestModal.js